import React, { memo } from "react";

import ThreeStarsSvg from "../../assets/icons/three-stars.svg";
import UserProfileSvg from "../../assets/icons/user-profile.svg";
import WheelSvg from "../../assets/icons/wheel-params.svg";

import useAuthContext from "../../hooks/useContext";
import useMediaQuery from "../../hooks/useMediaQuery";
import useSharedPropsForSettingsModal from "../../hooks/useSharedPropsForSettingsModal";

import { MEDIUM_SCREEN, SMALL_SCREEN } from "../../utils/breackpoints";
import isVisuelEffectSupported from "../../utils/checkPipelineSupport";

import IconSvg from "../IconSvg";

import AudioVideoConfig from "../SharedComponents/AudioVideoConfig";
import Modal from "../SharedComponents/Modal";
import ProfileSettings from "../SharedComponents/ProfileSettings";
import VisualEffectConfig from "../SharedComponents/VisualEffectConfig";

export const PreviewSettingOption = {
  VIDEO: "audio",
  VISUALEFFECT: "visualEffect",
  PROFILE: "profile",
};

const PreviewSettingOptionsList = [
  {
    label: PreviewSettingOption.VIDEO,
    title: "Audio and video",
    icon: WheelSvg,
    translate: "prejoin-button-audio-video",
  },
  {
    label: PreviewSettingOption.VISUALEFFECT,
    title: "Visual effects",
    icon: ThreeStarsSvg,
    translate: "btn-visual-effects",
  },
  {
    label: PreviewSettingOption.PROFILE,
    title: "Profile",
    icon: UserProfileSvg,
    translate: "settings-profile-title",
  },
];

const PreviewSettingsModal = ({
  closeModal,
  selectedSettingsOption,
  setSelectedSettingsOption,
}) => {
  const isPipelineSupported = isVisuelEffectSupported();
  const isPhoneScreen = useMediaQuery(SMALL_SCREEN);
  const isMediumScreen = useMediaQuery(MEDIUM_SCREEN);

  const { translateJSON } = useAuthContext();
  const {
    audioVideoConfigProps,
    profilConfigProps,
    visualEffectConfigProps,
    saveUpdated,
  } = useSharedPropsForSettingsModal();

  const handleClickSave = () => {
    saveUpdated();
    closeModal();
  };

  const renderOptionContent = () => {
    let content;
    switch (selectedSettingsOption) {
      case PreviewSettingOption.VIDEO:
        content = <AudioVideoConfig {...audioVideoConfigProps} />;
        break;
      case PreviewSettingOption.VISUALEFFECT:
        content = <VisualEffectConfig {...visualEffectConfigProps} />;
        break;
      case PreviewSettingOption.PROFILE:
        content = <ProfileSettings {...profilConfigProps} />;
        break;
      default:
        break;
    }
    return content;
  };

  if (isPhoneScreen && selectedSettingsOption === PreviewSettingOption.VIDEO) {
    closeModal();
  }

  return (
    <Modal
      closeModal={closeModal}
      headingTitle={!isPhoneScreen ? translateJSON["audiovideo-title"] : ""}
    >
      <div className="preview-settings-modal">
        <div className="preview-settings-modal__main">
          <div className="preview-settings-modal__options">
            {PreviewSettingOptionsList.filter((item) => {
              if (!isPipelineSupported) {
                return item.label !== PreviewSettingOption.VISUALEFFECT;
              }
              if (isMediumScreen) {
                return item;
              }
              return item.label !== PreviewSettingOption.VIDEO;
            }).map((option, index) => (
              <button
                key={index}
                className={`btn-icon ${selectedSettingsOption === option?.label ? "active" : ""}`}
                onClick={() => setSelectedSettingsOption(option?.label)}
                data-size={"large"}
              >
                <IconSvg svg={option.icon} />
                <span>{translateJSON[option.translate]}</span>
              </button>
            ))}
          </div>

          <div className="preview-settings-modal__content">
            {renderOptionContent()}
          </div>
        </div>

        <div className="preview-settings-modal__footer">
          <button className={"btn-regular"} onClick={closeModal}>
            <span>{translateJSON["btn-cancel"]}</span>
          </button>
          <button className={"btn-regular"} onClick={handleClickSave}>
            <span>{translateJSON["btn-save"]}</span>
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default memo(PreviewSettingsModal);
